/**
 * Electron Constants - Web Stub
 */

export const PERMISSION_STATUS = {
  GRANTED: 'granted',
  DENIED: 'denied',
  NOT_DETERMINED: 'not-determined',
} as const;
